import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable, catchError, map, timeout } from 'rxjs';
import { ApiClientConfig } from '../api-client.config';
import { PageInfoResponse } from './api.fanpage.models';

export class PageApi {
  private apiUrl = environment.API_URL;
  PAGE = '/page/pages';
  MODERATO = '/social-moderator';
  constructor(
    public readonly http: HttpClient,
    public config: ApiClientConfig
  ) {}

  getFanpageInfo(fanpageId: string | null): Observable<PageInfoResponse> {
    return this.http.get<PageInfoResponse>(`${this.apiUrl}${this.PAGE}/${fanpageId}`).pipe(
      timeout(this.config.responseTimeout),
      map(response => {
        return response;
      }),
      catchError(error => {
        throw error.error;
      })
    );
  }

  getApprovalRequestsFanpages({
    objectType = 'FANPAGE',
    pageNum = 0,
    pageSize = 10,
    sourceTypeArr = 'NEW|EDIT|REPORT',
    priorityTypeArr = 'YELLOW|RED|GREEN'
  }: any): Observable<any> {
    const params = new HttpParams()
      .set('pageNum', pageNum)
      .set('pageSize', pageSize)
      .set('objectType', objectType)
      .set('sourceTypeArr', sourceTypeArr)
      .set('priorityTypeArr', priorityTypeArr);
    const apiLink = `${this.apiUrl}${this.MODERATO}/moderate-contents/search`;
    return this.http.get<any>(apiLink, { params }).pipe(
      timeout(this.config.responseTimeout),
      map(res => {
        return res.data;
      }),
      catchError(err => {
        throw err.error;
      })
    );
  }
}
